import { ApiClientInstance } from '@shared/api';

export interface IUserInfoResponse {
  firstName: string;
  lastName: string;
  nationalCode: string;
  gender: number;
  genderTitle: string;
  birthDate: string;
  clubTotalRial: number;
  isInTseMarket: boolean;
  isSejami: boolean;
  hasUpdatedSejamInfo: boolean;
  displayName: string;
}
export const getUserInfo = (token: string) => {
  if (!token) return undefined;

  return ApiClientInstance.get<IUserInfoResponse>('v2/profile/userinfo', {
    anonymouse: true,
    headers: {
      Authorization: `Bearer ${token}`,
      'oauth-access-token': `${token}`,
    },
  });
};
